import { DOCUMENT } from '@angular/common';
import { Component, ElementRef, Inject, Input, OnInit, ViewChild } from '@angular/core';
import { Observable, of } from 'rxjs';

import { SidenavInterface } from './sidenav.interface';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss']
})
export class SidenavComponent implements OnInit {

  @ViewChild('sideNavBar',{static: true}) sideNavBar: ElementRef<HTMLInputElement>;

  @Input() links: SidenavInterface[] = [
    {
      label: 'Stations',
      icon: 'mic',
      link: '#',
      queryParam: {}
    }
  ];

  isExpanded = false;

  mainElementSettings: any;

  document: any;

  constructor(@Inject(DOCUMENT) document) {
    this.document = document;
  }

  ngOnInit() {
  }

  getQueryParam(queryParam: Object | Observable<Object>): Observable<Object> {
    if (queryParam instanceof Observable) {
      return queryParam;
    }

    const objectToObservable: Object = queryParam;
    return of(objectToObservable);
  }

  toggleSidebar() {
    if (!this.mainElementSettings) {
      this.mainElementSettings = {
        'left': this.document.getElementById('main').style.left,
        'width': this.document.getElementById('main').offsetWidth,
      };
    }
    if (this.isExpanded) {
      this.document.getElementById('main').style.left = this.mainElementSettings.left;
      this.document.getElementById('main').style.width = this.mainElementSettings.width + 'px';
    } else {
      this.document.getElementById('main').style.left = '100px';
      this.document.getElementById('main').style.width = (this.mainElementSettings.width - 100) + 'px';
    }
    this.isExpanded = !this.isExpanded;
  }

}
